import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { api } from "state/api";

/**
 * Listens for messages posted by the service worker. Today there is one:
 * `{type: "push-received"}`, sent when a push lands while the app is open —
 * we invalidate the Notifications tag so the bell badge (and an open
 * /notifications page) refetch immediately. Event-driven by design: the
 * house rule is no polling / focus timers, and this keeps the badge live
 * without either.
 */
export function useSwMessages() {
  const dispatch = useDispatch();

  useEffect(() => {
    if (typeof navigator === "undefined" || !navigator.serviceWorker) return;

    const onMessage = (event) => {
      if (event?.data?.type === "push-received") {
        dispatch(api.util.invalidateTags(["Notifications"]));
      }
    };

    navigator.serviceWorker.addEventListener("message", onMessage);
    return () =>
      navigator.serviceWorker.removeEventListener("message", onMessage);
  }, [dispatch]);
}
